"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Budget = function Budget() {
  return _react2.default.createElement(
    "g",
    { id: "budget" },
    _react2.default.createElement("path", { d: "M250,0 C112.2,0 0,112.2 0,250 C0,387.9 112.2,500 250,500 C387.8,500 500,387.9 500,250 C500,112.2 387.8,0 250,0 M45.5,250 C45.5,137.6 136.7,46.1 249,45.5 L249,251.7 L105.8,394.9 C68.6,357.8 45.5,306.6 45.5,250" })
  );
};

exports.default = Budget;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Budget.js
// module id = 2928
// module chunks = 4